export const SECURITY_HISTORY_SIZE = 8;
